export default "https://cdn-static.gokick.com/assets/90becb6b185a352a9c07d0641a2a2a86ee77cb9a/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";